export default class S3Axios {
    constructor(axios){
        this.s3Axios = axios.create();
        delete this.s3Axios.defaults.headers.common['Authorization'];
        const MAX_REQUESTS_COUNT = 5;
        const INTERVAL_MS = 40;
        let PENDING_REQUESTS = 0;

        /**
         * Axios Request Interceptor
         */
        this.s3Axios.interceptors.request.use((config) => {
            return new Promise((resolve) => {
                let interval = setInterval(() => {
                    if (PENDING_REQUESTS < MAX_REQUESTS_COUNT) {
                        PENDING_REQUESTS++;
                        clearInterval(interval);
                        resolve(config);
                    }
                }, INTERVAL_MS);
            })
        })

        //Handle token expire
        this.s3Axios.interceptors.response.use(
            (response) => {
                PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1);
                return response;
            },
            (error) => {
                // This function is part of a promise chain.
                // It needs to return a value or another promise so the caller knows when it
                // has completed.

                PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1);

                return Promise.reject(error);
            }
        );
    }
}
